import type { FC } from "react";

import type { CheckoutConfigurationCartOverviewTier } from "@jti/commerce";
import { CartOverviewTier as CartOverviewTierUI } from "@jti/ui/components/CartOverviewTier";

import { useCartOverviewTier } from "./hooks";

export type CartOverviewTierProps = Omit<CheckoutConfigurationCartOverviewTier, "enabled"> & {
  cartPoints: number;
};

export const CartOverviewTier: FC<CartOverviewTierProps> = (props) => {
  const tierData = useCartOverviewTier(props.cartPoints);

  if (tierData.isHidden || tierData.isFailed) {
    return null;
  }

  return <CartOverviewTierUI {...props} {...tierData} />;
};
